import { BasePage } from './../base.page';
import { finalize } from 'rxjs/operators';
import { UserModel } from './../../models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { WardrobeService } from './../../services/wardrobe.service';
import { PaginatedResponse } from 'src/app/models/paginated-response.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import {
  ProductCategoryModel,
  ProductListingParamsModel,
  ProductModel,
} from './../../models/wardrobe.model';
import { UserFriendsModalComponent } from 'src/app/components/user-friends-modal/user-friends-modal.component';
import {
  Platform,
  LoadingController,
  ToastController,
  IonInfiniteScroll,
  ModalController,
} from '@ionic/angular';
import { SubscribeNowModalComponent } from 'src/app/components/subscribe-now-modal/subscribe-now-modal.component';
import { ImageViewerComponent } from 'src/app/components/image-viewer/image-viewer.component';

@Component({
  selector: 'shc-user-detail',
  templateUrl: './user-detail.page.html',
  styleUrls: ['./user-detail.page.scss'],
})
export class UserDetailPage extends BasePage implements OnInit {
  userId: number;
  loading: boolean;
  userDetail: UserModel;
  segmentCurrent: number;
  callInProgress: boolean;
  products: PaginatedResponse<ProductModel>;
  categories: PaginatedResponse<ProductCategoryModel>;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  params: ProductListingParamsModel = new ProductListingParamsModel();



  averageRating: number = 0;
  msg: boolean = false;
  Math = Math;

  constructor(
    protected platform: Platform,
    userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private route: ActivatedRoute,
    private wardrobeService: WardrobeService,
    private modalCtrl: ModalController,
  ) {
    super(
      platform,
      userService,
      authService,
      translate,
      loadingCtrl,
      toastController,
    );
  }

  ngOnInit() {
    this.params.page = 1;
    if (!this.segmentCurrent) {
      this.segmentCurrent = 0;
    }
    this.callInProgress = true;
    this.userId = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    this.getCategories();
    this.getUserDetail();
  }

  ionViewWillEnter() { }

  segmentChanged(ev) {
    if (this.callInProgress) {
      return;
    }
    this.params.page = 1;
    this.segmentCurrent = parseInt(ev.target.value, 10);
    this.getUserProducts('');
  }

  // getUserDetail() {
  //   this.userService.getUserDetail(this.userId).subscribe(
  //     (res: UserModel) => {
  //       this.userDetail = res;
  //       this.getUserProducts();
  //     },
  //     (error) => {
  //       this.callInProgress = false;
  //       this.errorService.handle(error);
  //     },
  //   );
  // }

  getUserDetail() {
  this.userService.getUserDetail(this.userId).subscribe({
    next: (res: UserModel) => {
      this.userDetail = res;
      this.getUserProducts();

      this.userService.getUserRatings(this.userId).subscribe({
        next: (response) => {
          this.averageRating = response.average_rating;
          if (this.averageRating === 0) {
            this.msg = true;
          }
        },
        error: (err) => {
          console.error('Error fetching rating:', err);
        }
      });
    },
    error: (error) => {
      this.callInProgress = false;
      this.errorService.handle(error);
    }
  });
}




  // this.userService.getLoggedInUserId().subscribe({
  //       next: (userId) => {
  //         this.userService.getUserRatings(userId).subscribe({
  //           next: (response) => {
  //           this.averageRating = response.average_rating;
  //           if (this.averageRating === 0) {
  //             this.msg = true;
  //           }
  //         },
  //           error: (err) => {
  //             console.error('Error fetching rating:', err);
  //           }
  //         });
  //       },
  //       error: (err) => {
  //         console.error('Error getting user ID:', err);
  //       }
  //     });

  followUser() {
    this.userService.toggleFollowUser(this.userDetail.id).subscribe(
      (res) => {
        this.userDetail.is_following = !this.userDetail.is_following;
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  getUserProducts(event?: any) {
    this.loading = true;
    if (this.segmentCurrent === 0) {
      this.params.category_id = null;
    } else {
      this.params.category_id = this.segmentCurrent;
    }
    this.params.user_id = this.userId;
    this.showLoader();
    this.wardrobeService
      .productsList(this.params)
      .pipe(finalize(() => this.hideLoader()))
      .subscribe(
        (res: PaginatedResponse<ProductModel>) => {
          this.loading = false;
          this.callInProgress = false;
          if (this.products && this.products.meta) {
            if (this.params.page === 1) {
              this.products = res;
            } else {
              this.products.meta = res.meta;
              this.products.data = [...this.products.data, ...res.data];
            }
          } else {
            this.products = res;
          }
          if (event) {
            event.target.complete();
          }
          this.params.page++;
        },
        (error) => {
          this.loading = false;
          this.callInProgress = false;
          this.errorService.handle(error);
        },
      );
  }

  async userFollowing(type: string, userId: number) {
    const modal = await this.modalCtrl.create({
      component: UserFriendsModalComponent,
      componentProps: { type, userId },
      cssClass: 'following',
      id: 'userFriends',
      keyboardClose: true,
      backdropDismiss: true,
      canDismiss: true,
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the UserFriendsModalComponent modal is closed
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async userFollowers(type: string, userId: number) {
    const modal = await this.modalCtrl.create({
      component: UserFriendsModalComponent,
      componentProps: { type, userId },
      cssClass: 'following',
      id: 'userFriends',
      keyboardClose: true,
      backdropDismiss: true,
      canDismiss: true,
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the UserFriendsModalComponent modal is closed
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async subscribeNow() {
    const modal = await this.modalCtrl.create({
      component: SubscribeNowModalComponent,
      cssClass: 'subscribeNow',
      id: 'subscribeNow',
      keyboardClose: true,
      backdropDismiss: true,
      canDismiss: true,
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the SubscribeNowModalComponent modal is closed
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  getCategories() {
    this.wardrobeService.categoriesList({ page: 1, per_page: 40 }).subscribe(
      (res) => {
        this.categories = res;
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  loadData(event): void {
    if (this.products.meta.current_page < this.products.meta.last_page) {
      this.getUserProducts(event);
    } else {
      this.infiniteScroll.disabled = true;
    }
  }

  async showImageModal() {
    if (!this.userDetail?.avatar?.url) {
      return;
    }
    const imgUrl = this.userDetail?.avatar?.url;
    const modal = await this.modalCtrl.create({
      component: ImageViewerComponent,
      componentProps: {
        image: imgUrl
      },
    });

    return await modal.present();
  }
}
